import ICreditCard from "./ICreditCard"
import IDebitCard from "./IDebitCard"
import IPaypalRequest from "./IPaypalRequest"

interface ISignaturePagamento{
    forma: string,
    cartao?: ICreditCard,
    debito?: IDebitCard,
    paypal?: IPaypalRequest,
    valor: number,
    voucher?: string,
    parceiro?: string
}

export const instanceOfISignaturePagamento = (object: any) : object is ISignaturePagamento => {
    return 'forma' in object &&
            'valor' in object
}

export default ISignaturePagamento